import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    paper: {
        padding: theme.spacing(2)
    },
    rootFab: {
        alignSelf: 'flex-end',
        textAlign: 'end',
        [theme.breakpoints.down('sm')]: {
            alignSelf: 'center',
        }
    },
    buttonPerception:{
        padding: '0px'
    },
    success: {
        color: theme.palette.success.main
    },
    subAmount:{
        color: "#CCCCCC"
    },
    alerta: {
        color: theme.palette.error.main
    }
}))